import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getTemplates(type) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/templates/data/" + type, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching templates"
                    });
                }
            });
    },
    saveTemplate(templateObj) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/templates", templateObj)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            })
    },
    getTemplateData(templateId) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/templates/" + templateId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching template"
                    });
                }
            });
    },
    deleteTemplate(templateId) {
        axios.defaults.withCredentials = true;

        return axios.delete(constants.BASE_URL + "/templates/" + templateId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    },
    getSystemTemplates(templateName) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/email-templates/" + templateName, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching templates"
                    });
                }
            });
    }, saveSystemTemplates(templateData) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/email-templates",templateData)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while saving templates"
                    });
                }
            });
    }


}
